import { request } from '../helpers/request';
import { Project } from '../helpers/types';

export interface CreateProjectPayload {
  name: string;
  description?: string;
  sourceLanguage: string;
  targetLanguages?: string[];
}

export interface AddMemberPayload {
  email: string;
  role: string;
}

export const projectsApi = {
  list: () => request<Project[]>('/projects'),

  get: (projectId: string) => request<Project>(`/projects/${projectId}`),

  create: (payload: CreateProjectPayload) =>
    request<Project>('/projects', { method: 'POST', body: payload }),

  update: (projectId: string, payload: Partial<CreateProjectPayload>) =>
    request<Project>(`/projects/${projectId}`, {
      method: 'PATCH',
      body: payload,
    }),

  remove: (projectId: string) =>
    request<void>(`/projects/${projectId}`, { method: 'DELETE' }),

  addMember: (projectId: string, payload: AddMemberPayload) =>
    request<Project>(`/projects/${projectId}/members`, {
      method: 'POST',
      body: payload,
    }),

  removeMember: (projectId: string, memberId: string) =>
    request<Project>(`/projects/${projectId}/members/${memberId}`, {
      method: 'DELETE',
    }),

  addLanguage: (projectId: string, code: string) =>
    request<Project>(`/projects/${projectId}/languages`, {
      method: 'POST',
      body: { code },
    }),

  removeLanguage: (projectId: string, code: string) =>
    request<Project>(`/projects/${projectId}/languages/${code}`, {
      method: 'DELETE',
    }),
};
